// simply forward the menu/meatballProfileLayout
import MeatballProfileLayout from '../menu/MeatballProfileLayout';
export default MeatballProfileLayout;
